import appConfig from '@nerdwallet/app-config';

export const getMonetizableValue = (marketplaceEntity, isBanking) => {
  // eslint-disable-next-line camelcase
  const { should_throttle_monetization, monetizable } =
    marketplaceEntity.derived_details;
  const isMonetizable = isBanking
    ? !should_throttle_monetization?.value
    : monetizable?.value;

  return isMonetizable ? 'yes_assumed' : 'no';
};

export const addCtaApplyNowLinkTracking = (
  marketplaceEntity,
  segmentImpressionId,
  pageViewId,
  isBanking
) => {
  if (marketplaceEntity.derived_details?.apply_link?.value) {
    const applyLinkUrl = marketplaceEntity.derived_details?.apply_link?.value;
    const delimeter = applyLinkUrl && applyLinkUrl.includes('?') ? '&' : '?';
    const segmentParams = new URLSearchParams({
      impression_pageview_id: pageViewId,
      sku_impression_id: segmentImpressionId,
      product_impression_id: segmentImpressionId,
      // eslint-disable-next-line no-underscore-dangle
      calling_deployable_name: appConfig?._meta?.deployable,
      // eslint-disable-next-line no-underscore-dangle
      calling_deployable_version: appConfig?._meta?.version,
      // eslint-disable-next-line no-underscore-dangle
      deployable_name: appConfig?._meta?.deployable,
      // eslint-disable-next-line no-underscore-dangle
      deployable_version: appConfig?._meta?.version,
      sku_id: marketplaceEntity?.id,
      sku_level: marketplaceEntity?.entity_type,
      // sku_name: marketplaceEntity?.name,
      sku_product_type: marketplaceEntity?.product_type,
      sku_source: 'marketplace',
      monetizable: getMonetizableValue(marketplaceEntity, isBanking),
    });

    const updatedUrl = `${applyLinkUrl}${delimeter}${segmentParams.toString()}`;
    return {
      ...marketplaceEntity,
      derived_details: {
        ...marketplaceEntity.derived_details,
        apply_link: {
          type: 'link',
          value: updatedUrl,
        },
      },
    };
  }

  return marketplaceEntity;
};

export const addCtaApplyNowLinkSegmentTracking = (
  marketplaceEntity,
  searchParams
) => {
  if (marketplaceEntity.derived_details?.apply_link?.value) {
    const updatedUrl = new URL(
      marketplaceEntity.derived_details?.apply_link?.value
    );

    Object.keys(searchParams).forEach((key) => {
      updatedUrl.searchParams.append(key, searchParams[key]);
    });

    return {
      ...marketplaceEntity,
      derived_details: {
        ...marketplaceEntity.derived_details,
        apply_link: {
          type: 'link',
          value: updatedUrl.toString(),
        },
      },
    };
  }
  return marketplaceEntity;
};

export const baseSegmentAnalytics = {
  // eslint-disable-next-line no-underscore-dangle
  deployableName: appConfig?._meta?.deployable,
  // eslint-disable-next-line no-underscore-dangle
  deployableVersion: appConfig?._meta?.version,
};

export const baseSegmentAnalyticsWithCallingAttrs = {
  // eslint-disable-next-line no-underscore-dangle
  deployableName: appConfig?._meta?.deployable,
  // eslint-disable-next-line no-underscore-dangle
  deployableVersion: appConfig?._meta?.version,
  // eslint-disable-next-line no-underscore-dangle
  calling_deployable_name: appConfig?._meta?.deployable,
  // eslint-disable-next-line no-underscore-dangle
  calling_deployable_version: appConfig?._meta?.version,
};
